import { FormFieldAutocomplete } from '@/global/components/Form'
import { useFocoCampo } from '@/hooks'
import { segmentos_api } from '@/service/api'
import { useState } from 'react'
import { useFormContext } from 'react-hook-form'

interface IProps {
    /** Caminho do campo no react-hook-form. Padrão: "Segmento.nome" */
    name?: string
    /** Desabilita apenas esta instância, além do disabled global do form */
    disabled?: boolean
    /** Chamado com o nome escolhido sempre que o valor muda (seleção real, não a cada tecla) */
    onSelecionar?: (nome: string) => void
    /** Padrão true. Usar false quando o campo pode ficar vazio (ex.: seleção em lote, item por item) */
    required?: boolean
}

export function AutocompleteSegmento({
    name = 'Segmento.nome',
    disabled,
    onSelecionar,
    required = true,
}: IProps) {
    const { setValue } = useFormContext()

    const { ref: refFoco, deveFocar } = useFocoCampo<HTMLDivElement>('Segmento')
    const [busca, setBusca] = useState('')

    const { data: segmentos = [] } = segmentos_api.useFetch({
        enabled: true,
        refetchOnWindowFocus: false,
    })

    const nomes = segmentos.map(segmento => segmento.nome)

    const digitado = busca.trim()
    const jaExiste = nomes.some(
        nome => nome.toLowerCase() === digitado.toLowerCase(),
    )

    return (
        // O ref rola a tela até o gatilho quando a URL pede foco nele.
        <FormFieldAutocomplete
            triggerRef={refFoco}
            name={name}
            rules={required ? { required: 'Obrigatório' } : undefined}
            disabled={disabled}
            label="Segmento"
            placeholder="Digite ou escolha o segmento"
            required={required}
            options={nomes}
            onChange={novoValor => {
                if (novoValor) onSelecionar?.(novoValor)
            }}
            onInputChange={setBusca}
            searchPlaceholder="Buscar ou digitar para criar um segmento"
            creatableOption={
                digitado && !jaExiste
                    ? {
                          label: `Outro: ${digitado}`,
                          onClick: () => {
                              setValue(name, digitado, {
                                  shouldValidate: true,
                                  shouldDirty: true,
                              })
                              onSelecionar?.(digitado)
                          },
                      }
                    : undefined
            }
            helperText={
                deveFocar ? 'Por favor, incluir o segmento.' : undefined
            }
        />
    )
}
